import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { supportedLngs } from "config/i18n";

export interface LocaleOption {
  value: string;
  label: string;
}

/**
 * The supported locales as picker options, labelled with each language's own name.
 *
 * Labels come from `locale.display_name_<locale>` in the translation files rather than
 * Intl.DisplayNames, which is unavailable or broken on some clients and needed an async
 * polyfill. The values are autonyms and deliberately identical in every language file, so
 * a user who cannot read the current UI language can still find their own -- they must not
 * be translated.
 */
function useLocalesList(): LocaleOption[] {
  const { t } = useTranslation();

  return useMemo(
    () =>
      supportedLngs.map((locale) => ({
        value: locale,
        label: t(`locale.display_name_${locale}`),
      })),
    [t]
  );
}

export default useLocalesList;
